import ajaxServiceByApiGateway from './ajaxServiceByApiGateway';

export default {
  // 取得活動資料
  getActivity(param, headers) {
    return ajaxServiceByApiGateway.get('/getactactivityv1', param, headers);
  },
  // 取得活動參數
  getActivityParameter(param, headers) {
    // 不傳參數=全取
    return ajaxServiceByApiGateway.get('/getactactivityparameterv1', param, headers);
  },
  // 新增活動結果資料
  createActivityResult(body, headers) {
    return ajaxServiceByApiGateway.post('/createactactivityresultv1', body, headers);
  },
  // 取得活動結果資料
  getActivityResult(param, headers) {
    return ajaxServiceByApiGateway.get('/getactactivityresultv1', param, headers);
  },
  // 更新活動結果資料
  updateActivityResult(body, headers) {
    return ajaxServiceByApiGateway.put('/updateactactivityresultv1', body, headers);
  },
  // 更新活動結果聯絡資料
  patchCommunicationData(body, headers) {
    return ajaxServiceByApiGateway.put('/updateactcommunicationdatav1', body, headers);
  },
  // 取得MGM活動資料
  getMGMData(param) {
    return ajaxServiceByApiGateway.get('/getactmgmdatav1', param);
  },
  // 紀錄MGM活動受邀頁
  postMGMLog(body) {
    return ajaxServiceByApiGateway.post('/postactmgmlogv1', body);
  },
  // mgm活動贈獎(包含註冊/綁定/首購)(可批量)
  postMGMActivity(body) {
    return ajaxServiceByApiGateway.post('/postactmgmactivityv2', body);
  },
};
